<template>
  <el-dialog :visible.sync="visible"  title="选择部门" width="tabValue === 'tree' ? '500px' : '500px'" top="10vh" :before-close="closeDialog" :close-on-click-modal="false">
    <el-tabs type="border-card" visible.sync="tabValue" v-model="tabValue">
      <el-tab-pane label="选择组织" name="tree">
        <div class="department-list" v-loading="loading">
          <el-tree ref="tree" :props="{ label: 'department_name' }" default-checked-keys="defaultCheckedKeys" show-checkbox lazy :load="getDepartmentList"></el-tree>
        </div>
      </el-tab-pane>
      <el-tab-pane label="筛选组织" name="search">
        <div class="search-bar">
          <span class="label">部门名称</span>
          <el-input class="inp" v-model="searchKeyword" clearable />
          <el-button class="btn" type="primary" @click="searchDepartment()">搜索</el-button>
        </div>
        <div class="department-list department-wrap" v-loading="loading">
          <!--          <el-transfer v-model="selectedData" :props="{ key: 'id', label: 'ancestor_name' }" :titles="['未选中', '已选中']" :data="searchData" />-->
          <select multiple class="list-item" id="search-data">
            <option v-for="item in searchData" :key="item.id" :value="item.id">{{ item.ancestor_name }}</option>
          </select>
          <div class="search-btns">
            <el-button class="btn" type="primary" @click="insert">＞</el-button>
            <el-button class="btn" type="primary" @click="remove">＜</el-button>
          </div>
          <select multiple class="list-item" id="selected-data">
            <option v-for="item in selectedData" :key="item.id" :value="item.id">{{ item.ancestor_name }}</option>
          </select>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="btns">
      <el-button type="primary" @click="getCheckedKeys()">确定</el-button>
      <el-button @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import http from "@/components/Admin/Flow/common/Http";
import _ from "lodash";
export default {
  name: "DepartmentSelect",
  props: {
    selectType: {
      type: Number,
      default: 1,
    },
    showName: {
      type: String,
      default: "选择发送员工",
    },
    modal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      treeProps: { label: 'department_name' },
      visible:false,
      tabValue: "tree",
      showCheckbox: false,
      loading: false,
      defaultCheckedKeys: [],
      treeKey: '',
      searchKeyword: '',
      searchData: [],
      searchList: [],
      selectedData: [],
    };
  },
  mounted() {

  },
  watch: {
    page(n, o) {
      this.getUserList();
    },
    departmentId(n, o) {
      this.getUserList();
    },
  },
  methods: {
    getDepartmentList(node, resolve) {
      setTimeout(() => {
        let parent_id = 0
        let that = this
        if (typeof node.data != "undefined") {
          parent_id = node.data.id
        }
        if(parent_id == 0) that.loading = true
        http.get('hrm/department/list', {parent_id: parent_id}, res => {
          that.loading = false
          resolve(res.code == 0 ? res.data : [])
        })
      }, 500);
    },
    closeDialog() {
      this.visible = false
    },
    insert() {
      const ids = this.getSelectedIds('search-data')
      let newList = []
      this.searchList.forEach(item => {
        if (ids.includes(item.id)) {
          newList.push(item)
          console.info(newList)
        }
      })
      this.selectedData = this.selectedData.concat(newList)
      this.updateSearchList()
    },
    getSelectedIds(el) {
      const selectedOptions = document.getElementById(el).selectedOptions
      let ids = []
      for (let i = 0; i < selectedOptions.length; i++) {
        ids.push(Number(selectedOptions[i].value))
      }
      return ids
    },
    updateSearchList() {
      this.$nextTick(() => {
        const ids = this.selectedData.map(item => item.id)
        let newList = []
        this.searchList.forEach(item => {
          if(!ids.includes(item.id)) {
            newList.push(item)
          }
        })
        this.searchData = newList
      })
    },
    remove() {
      const all = this.selectedData.map(item => item.id)
      const ids = this.getSelectedIds('selected-data')
      const diff = all.filter(id => !ids.includes(id))
      let newList = []
      this.selectedData.forEach(item => {
        if(diff.includes(item.id)) {
          newList.push(item)
        }
      })
      this.selectedData = newList
      this.updateSearchList()
    },

    getCheckedKeys() {
      let data = []
      if(this.tabValue === 'tree') {
        // const nodes = this.showCheckbox ? this.$refs.tree.getCheckedNodes() : [this.$refs.tree.getCurrentNode()]
        const nodes = this.$refs.tree.getCheckedNodes()
        data = nodes.map(item => { return { id: item.id, name: item.department_name, ancestor_name: item.ancestor_name }})
      } else {
        data = this.selectedData.map(item => {
          return { id: item.id, name: item.department_name, ancestor_name: item.ancestor_name }
        })
      }
      this.defaultCheckedKeys = data
      this.$emit('onSelected', this.type, data)
      this.closeDialog()
    },
    show(t, d) {
      this.type = t
      this.defaultCheckedKeys = typeof d == 'object' ? d.map(item => item.id) : []
      this.treeKey = new Date().getTime()
      if (t == 'search') {
        this.selectedData = d
      } else {
        this.selectedData = []
      }
      this.searchData = []
      this.searchList = []
      this.visible = true
    },
    searchDepartment() {
      http.get('hrm/department/list', { keyword: this.searchKeyword }, res => {
        this.loading = false
        let searchList = res.code === 0 ? res.data : []
        this.searchList = searchList
        this.searchData = searchList
        if(this.selectedData.length) {
          this.updateSearchList()
        }
      })
    },
  },
};


</script>

<style lang="scss" scoped>
.department-list {
  height: calc(80vh - 200px);
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}

.btns {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.department-wrap {
  display: flex;
  justify-content: center;
  align-items: center;

  .list-item {
    width: 350px;
    height: 100%;
    border: 1px solid #ddd;
    outline: none;
    padding: 5px;
    overflow: auto;
  }

  .search-btns {
    text-align: center;

    .el-button {
      margin: 0;

      &:nth-child(2) {
        margin-top: 10px;
      }
    }
  }
}

//:deep(.el-transfer) {
//  display: flex;
//  justify-content: center;
//  align-items: center;
//
//  .el-transfer__buttons {
//    padding: 10px;
//
//    .el-transfer__button {
//      display: block;
//
//      &:nth-child(2) {
//        margin: 0;
//        margin-top: 10px;
//      }
//    }
//  }
//
//  .el-transfer-panel__body,.el-transfer-panel__list  {
//    height: 356px;
//  }
//
//  .el-transfer-panel{
//    width: 350px
//  }
//
//  .el-transfer-panel__item.el-checkbox .el-checkbox__label {
//    overflow: unset;
//  }
//}
//
.search-bar {
  margin-left: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .label {
    width: 70px;
  }

  .inp {
    width: 200px
  }

  .btn {
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/departmentSelect.vue